"use strict";

// NativeModules shim
var NativeModules = {};
module.exports = NativeModules;


// WEBPACK FOOTER //
// /Users/david/Dev/project_rnweb/react-native-web/packages/react-native-web/dist/exports/NativeModules/index.js